import React from 'react';

import './Modal.css';

function ModalWrapper(props) {
  let content = props.modalText;
  function openModal(event) {
    if (typeof content === 'string') {
      content = <div dangerouslySetInnerHTML={{ __html: content }} />;
    }
    props.onOpenModal(content);
  }

  return (
    <>
      {props.modalText && (
        <span onClick={openModal} className="modal_wrapper">
          {props.children}
        </span>
      )}
      {!props.modalText && props.children}
    </>
  );
}
export default ModalWrapper;
